import {extractDocs} from '~/utils/transform-payload'

export function useArticles() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const list = async () => {
    const response = await sdk.find({
      collection: 'articles',
      depth: 2, // Populates image and category with icon
      limit: 100,
      sort: '-createdAt', // Payload uses '-' prefix for descending
      where: {
        _status: {equals: 'published'},
      },
    })

    const articles = extractDocs(response)

    return articles
  }

  const fetchBySlug = async (slug: string) => {
    const response = await sdk.find({
      collection: 'articles',
      draft: !!route.query.preview,
      depth: 2, // Populates image, authors with images, category with icon
      where: {
        slug: {equals: slug},
      },
      limit: 1,
    })

    const articles = extractDocs(response)
    const article = articles[0]
    if (!article) return null
    return article
  }

  return {
    list,
    fetchBySlug,
  }
}
